import { usePageContext } from 'application/contexts/PageContext';
import { ArticleJsonLd } from './ArticleJsonLd';
import { ContentPageJsonLd } from './ContentPageJsonLd';
import { FilteredLibraryPageJsonLd } from './FilteredLibraryPageJsonLd';

// A page is exactly one of these types - dispatch to exactly one, same lookup-map convention as
// ModuleFeature/PageTypeFeature. Organization/Breadcrumb/Team/Faq stay separate in Meta.tsx since
// they're independent scans, not alternatives to pick between.
const SCHEMA_BY_DOCUMENT_TYPE: Record<string, React.FC> = {
	articlePage: ArticleJsonLd,
	newsPage: ArticleJsonLd,
	newsPageWithTags: ArticleJsonLd,
	contentPage: ContentPageJsonLd,
	filteredLibraryPage: FilteredLibraryPageJsonLd,
};

export const PageSchemaJsonLd: React.FC = () => {
	const pageContext = usePageContext();
	const SchemaComponent = SCHEMA_BY_DOCUMENT_TYPE[pageContext?.documentType];
	return SchemaComponent ? <SchemaComponent /> : null;
};
